import React from 'react'
import classNames from 'classnames'

const Page = ({id, odd, children}) => {
  const pageClass = classNames('m-page', {'m-odd': odd})
  return (
    <div className={pageClass}>
      <div id={id}>{children}</div>
    </div>
  )
}

export default Page



// WEBPACK FOOTER //
// ./src/components/Page/Page.js